import './index.css';
import { jsx, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useLoadingState } from '@hh.ru/magritte-common-use-loading-state';
import { useSkeletonAnimationSync } from './useSkeletonAnimationSync.js';
import 'react';

var styles = {"skeleton":"magritte-skeleton___QviDX_2-1-26","fade-out":"magritte-fade-out___gf9o4_2-1-26","fadeOut":"magritte-fade-out___gf9o4_2-1-26","fade-in":"magritte-fade-in___EhxN0_2-1-26","fadeIn":"magritte-fade-in___EhxN0_2-1-26","skeleton-inline":"magritte-skeleton-inline___8IOsa_2-1-26","skeletonInline":"magritte-skeleton-inline___8IOsa_2-1-26"};

const Skeleton = ({ children, width, height, borderRadius, borderTopLeftRadius, borderTopRightRadius, borderBottomLeftRadius, borderBottomRightRadius, inline = false, additionalClass = '', loading = false, }) => {
    const isLoading = useLoadingState() || loading;
    const ref = useSkeletonAnimationSync(isLoading);
    const isHalfHeight = [
        borderRadius,
        borderBottomLeftRadius,
        borderBottomRightRadius,
        borderTopLeftRadius,
        borderTopRightRadius,
    ].includes('halfHeight');
    if (isLoading) {
        return (jsx("div", { ref: ref, className: classNames(styles.skeleton, additionalClass, { [styles.skeletonInline]: inline }), style: additionalClass
                ? {}
                : Object.fromEntries(Object.entries({
                    width,
                    height,
                    ...(isHalfHeight
                        ? { borderRadius: 'halfHeight' }
                        : {
                            borderRadius,
                            borderTopLeftRadius,
                            borderTopRightRadius,
                            borderBottomLeftRadius,
                            borderBottomRightRadius,
                        }),
                })
                    .filter((entry) => entry[1] !== undefined)
                    .map((radius) => (radius[1] === 'halfHeight' ? [radius[0], 99999] : radius))) }));
    }
    return jsx(Fragment, { children: children });
};

export { Skeleton };
//# sourceMappingURL=Skeleton.js.map
